module.exports = __webpack_public_path__ + "static/mocka-9d3462bc5ca105a47956ce4a99eb9330.jpg";